/* 🤖 this file was generated by script */
export const wiconSlashCircle01 = {
  name: 'slash_circle_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.93 4.93l14.14 14.14M22 12a10 10 0 11-20 0 10 10 0 0120 0z"/></svg>`,
};
